module.exports = __webpack_public_path__ + "img/paypal.2c032a6c.svg";